import React, { useState } from 'react'
import './PlusMenu.css'

export default function PlusMenu(props) {

    const [isActive, setIsActive] = useState(false)
    function activate() {
        setIsActive(isActive=>!isActive)
    }

    return (
        <li className={props.liClass} ref={props.refer}>
            <button onClick={() => activate()} id={props.id} className={`${props.buttonClass}${isActive ? ' active' : ''}`}><h2>{props.text}</h2><i className={isActive ? "bi bi-chevron-up":"bi bi-chevron-down"}></i></button>
            <div className={props.contentContainerClass}>
                {props.content}
            </div>
        </li>
    )
}